import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 100%;

  input {
    height: 100%;
    width: 100%;
    color: ${(props) => props.theme.colors.text.placeholder};
    font-size: 12px;
    background-color: ${(props) => (props.background
    ? props.background
    : props.theme.colors.UploadSurveyInputColor)};
    padding: 12px 35px 12px 16px;
    border-radius: 10px;
    border: ${(props) => props.hasError ? `1px solid ${props.theme.colors.statusError}` : 0};

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
      font-weight: 300;
    }
  }
`;
